import React from 'react';
import tpl from '../templates/fop-accounts';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';
import {apiback} from '../../../../../config';
import CreditsModel from '../../../Models/credits.m';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            tab: 'tariffs',
            mode: 'account_credit_limit_fop',
            qrOverride: null
        };
    }

    toggleModal = () => {
        const willOpen = !this.state.showModal;
        this.setState({showModal: willOpen, qrOverride: null});
        document.body.classList.toggle('disable-scroll', willOpen);
    };

    openOverrideQrModal = qr => {
        this.setState({showModal: true, qrOverride: qr});
        document.body.classList.add('disable-scroll');
    };

    componentDidMount() {
        super.componentDidMount();
        fetch(apiback('ACCOUNT_CREDIT_CALC'))
            .then(res => {
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                return res.json();
            })
            .then(json => {
                const model = new CreditsModel(json.data, this.state.mode);
                this.setState({model});
            })
            .catch(err => {
                console.error('[FopAccounts] Failed to load credit calc data:', err);
                this.setState({calcError: true});
            });
    }

    static displayName = 'FopAccounts.Views.Main';
}
